import React from "react"
import { Icon } from "../icon"
import type { IconName } from "../icon"

export function MenuItemIcon({
  name,
  className,
  size = "md"
}: {
  name: IconName
  /** For an icon whose colour carries meaning, such as a status dot. */
  className?: string
  /** Smaller for a glyph that reads as a marker rather than an icon. */
  size?: "xs" | "sm" | "md"
}) {
  return (
    <Icon
      name={name}
      size={size}
      className={className}
      data-slot="menu-item-icon"
    />
  )
}

MenuItemIcon.displayName = "Menu.ItemIcon"
